import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Highlight from 'LegacyWeployDesignLanguage/Highlight';
import { Chip } from 'LegacyWeployDesignLanguage/Tag';

const DEFAULT_CHIP_MAX_WIDTH = 'none';

const isValidCssValue = (value) => {
  const cssValuePattern = /\b(\d*)(px|%|rem|em)\b/;

  return cssValuePattern.test(value);
};

const StyledChip = styled(Chip)`
  max-width: ${props => props.tagMaxWidth};
`;

const StyledTagText = styled(Highlight)`
  color: ${props => props.theme.colors.text.primary};
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Tags = ({
  tags,
  searchTerms,
  className,
  tagMaxWidth,
}) => (
  <div className={className}>
    { (tags.length === 0)
      ? null
      : tags.map(tag => (
        <StyledChip
          key={tag}
          tagMaxWidth={isValidCssValue(tagMaxWidth) ? tagMaxWidth : DEFAULT_CHIP_MAX_WIDTH}
        >
          <StyledTagText
            searchTerms={searchTerms}
            text={tag}
          />
        </StyledChip>
        ))
    }
  </div>
);

Tags.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.string),
  searchTerms: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
  tagMaxWidth: PropTypes.string,
};

Tags.defaultProps = {
  tags: [],
  searchTerms: [],
  className: '',
  tagMaxWidth: DEFAULT_CHIP_MAX_WIDTH,
};

export default Tags;
